import { useMemo } from 'react';
import { FeatureFlags } from '../api/company/companies.models';
import { useGetMyCompanies } from './api/company.api';

const useFeatureFlags = () => {
  const { data: companies } = useGetMyCompanies(false);

  const featureFlags: FeatureFlags = useMemo(() => {
    const f = companies?.[0]?.featureFlags;
    return {
      CommentStress: !!f && f?.CommentStress === true,
      CompanyAction: !!f && f?.CompanyAction === true,
      GamificationChallenges: !!f && f?.GamificationChallenges === true,
      GamificationLeaderboard: !!f && f?.GamificationLeaderboard === true,
      Harmonia: !!f && f?.Harmonia === true,
      HarmoniaForHrs: !!f && f?.HarmoniaForHrs === true,
      PulseSurvey: !!f && f?.PulseSurvey === true,
    };
  }, [companies]);

  return [featureFlags, !!featureFlags] as [FeatureFlags, boolean];
};

export default useFeatureFlags;
